






















































import { Component } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import ArticleApi from '@/api/article/index'
import PicModal from '@/components/upload/picModal.vue'

@Component({
  components: {
    PicModal
  }
})
export default class EditArticleCategory extends AbpBase {
  form = {
    name: null,
    pictureUrl: null,
    sort: 0,
    published: false
  }

  ruleForm = {
    pictureUrl: [{ required: true, message: '请选择分类图', trigger: 'blur' }],
    name: [
      { required: true, message: '请输入分类名称', trigger: 'blur' }
    ]
  }

  created() {
    this.getCategory()
  }

  /**
   * 获取指定文章分类
   */
  getCategory() {
    let id = this.$route.query['id']
    if (id) {
      ArticleApi.getCategory(id.toString()).then(res => {
        this.form = res.data
      })
    }
  }

  picChange(e) {
    this.form.pictureUrl = e[0].url
  }

  submit() {
    let vm = this
    let form: any = vm.$refs.form
    form.validate(valid => {
      if (valid) {
        let id = vm.$route.query['id'] ? vm.$route.query['id'].toString() : null
        ArticleApi.createOrUpdateCategory(vm.form, id).then(res => {
          vm.$router.push({
            name: 'articleCategoryList'
          })
        })
      }
    })
  }
}
